// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function Loading$Component(Props) {
  return React.createElement("div", {
              className: "loadingio-spinner-spinner-fx8u0bmspjo"
            }, React.createElement("div", {
                  className: "ldio-evtb68yxbc5"
                }, React.createElement("div", undefined), React.createElement("div", undefined), React.createElement("div", undefined), React.createElement("div", undefined), React.createElement("div", undefined), React.createElement("div", undefined), React.createElement("div", undefined), React.createElement("div", undefined), React.createElement("div", undefined), React.createElement("div", undefined)));
}

var Component = {
  make: Loading$Component
};

function Loading(Props) {
  return React.createElement("div", {
              className: "flex items-center -mt-32 min-h-screen"
            }, React.createElement(Loading$Component, {}));
}

var make = Loading;

export {
  Component ,
  make ,
  
}
/* react Not a pure module */
